import React, { useState, useEffect } from "react";
import { RetellWebClient } from "retell-client-js-sdk";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

// HARDCODED VALUES - NO MORE ENV VARIABLES
const API_BASE = process.env.REACT_APP_API_BASE;
const voiceAgentId = "agent_ba612d5be62c2db2adb5713ba2";

const retellWebClient = new RetellWebClient();

export default function App() {
  const [isCalling, setIsCalling] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("id");
  const [data, setData] = useState({});

  // Set custom title
  useEffect(() => {
    document.title = "Aibiliti Voice Support";
  }, []);

  // Voice agent listeners
  useEffect(() => {
    retellWebClient.on("call_started", () => setIsCalling(true));
    retellWebClient.on("call_ended", () => setIsCalling(false));
    retellWebClient.on("error", () => {
      retellWebClient.stopCall();
      setIsCalling(false);
    });
  }, []);

  // Fetch user data
  useEffect(() => {
    if (token) {
      console.log("Fetching user data from:", `${API_BASE}/chat/get-user-data`);
      axios.post(`${API_BASE}/chat/get-user-data`, { user_email: token })
        .then((res) => {
          const json = res.data;
          setData({
            name: json.user.name,
            company: json.user.company,
            designation: json.user.title,
            email_id: json.user.email,
            company_description: "",
            email_subject: json.emails[0].subject,
            email: json.emails[0].body,
          });
        })
        .catch((err) => {
          console.log("Error fetching user data:", err);
        });
    }
  }, [token]);

  // Start/end voice agent conversation
  const toggleConversation = async () => {
    if (isCalling) {
      retellWebClient.stopCall();
      setIsCalling(false);
    } else {
      try {
        console.log("Making API call to:", `${API_BASE}/chat/create-web-call`);
        console.log("Using API_BASE:", API_BASE);
        console.log("Using voiceAgentId:", voiceAgentId);
        
        const registerCallResponse = await registerCall(voiceAgentId);
        if (registerCallResponse.access_token) {
          retellWebClient
            .startCall({
              accessToken: registerCallResponse.access_token,
            })
            .catch(console.error);
          setIsCalling(true);
        }
      } catch (error) {
        console.error("Error starting call:", error);
        alert("Error starting call: " + error.message);
      }
    }
  };

  async function registerCall(voiceAgentId) {
    const url = `${API_BASE}/chat/create-web-call`;
    console.log("Final API URL:", url);
    
    const requestBody = {
      agent_id: voiceAgentId,
      retell_llm_dynamic_variables: {
        designation: data?.designation || "",
        first_name: data?.name || "",
        company_description: data?.company_description || "",
        email_id: data?.email_id || "",
        email: data?.email || "",
        email_subject: data?.email_subject || "",
        company_name: data?.company || "",
      },
    };
    
    console.log("Request body:", requestBody);
    
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });
    
    console.log("Response status:", response.status);
    console.log("Response URL:", response.url);
    
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} - ${response.statusText}`);
    }
    
    return response.json();
  }

  // Call icon SVG
  const CallIcon = (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#222" />
      <path d="M17 15.5V17a2 2 0 0 1-2 2A13 13 0 0 1 5 7a2 2 0 0 1 2-2h1.5a1 1 0 0 1 1 0.8l0.5 2A1 1 0 0 1 9.5 9L8.1 10.4a10.72 10.72 0 0 0 5.5 5.5l1.4-1.4a1 1 0 0 1 1.2-0.2l2 0.5a1 1 0 0 1 0.8 1V15.5z" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f7f7f7",
      }}
    >
      {/* Agent Avatar - Same as your original */}
      <img
        src={process.env.PUBLIC_URL + "/agent-avatar.jpg"}
        alt="Prospec Agent"
        style={{
          width: "90px",
          height: "90px",
          borderRadius: "50%",
          objectFit: "cover",
          marginBottom: "18px",
          marginTop: "10px"
        }}
      />
      
      {/* Same title and text as your original */}
      <div style={{ fontWeight: 700, fontSize: "1.35rem", marginBottom: 10, color: "#222" }}>
        Hi, I am Meena
      </div>
      <div style={{ fontSize: 16, color: "#444", marginBottom: 22, maxWidth: 400, textAlign: "center" }}>
        I am here to answer questions you may have about Aibiliti. Just click the button below.
      </div>
      <button
        onClick={toggleConversation}
        style={{
          width: 220,
          padding: "1.1rem 0",
          backgroundColor: isCalling ? "#e63946" : "#222",
          color: "#fff",
          fontWeight: 600,
          fontSize: "1.13rem",
          border: "none",
          borderRadius: "28px",
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          transition: "background 0.2s"
        }}
      >
        {CallIcon}
        {isCalling ? "End Voice Call" : "Start Voice Call"}
      </button>
    </div>
  );
}